import { render, staticRenderFns } from "./people.vue?vue&type=template&id=707670de"
import script from "./people.vue?vue&type=script&lang=js"
export * from "./people.vue?vue&type=script&lang=js"
import style0 from "./people.vue?vue&type=style&index=0&id=707670de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports